// EventsList/index.js
import { connect } from 'react-redux';
import EventsList from '../../components/EventsList';
import { documentType } from '../../constants';

import {
  fetchAllEventsForBranchDispatch,
  openEditEventPanelDispatch,
  openEditEventDialogDispatch,
  eventEditClickDispatch,
  openDeleteEventDialogDispatch,
  submitDeleteEventRequestDispatch,
  fetchAllDocumentsDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    events: state.events.eventsByBranch.items,
    openDeleteDialog: state.events.deleteEvent.openDialog,
    eventToBeDeleted: state.events.deleteEvent.event,
    errorMessage: state.events.deleteEvent.errorMessage,
    isDeletingEvent: state.events.deleteEvent.isSaving,
    documents: state.settings.allDocuments.items,
    loggedInUser: state.users.user.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllEventsForBranch: (branchId) => {
      dispatch(fetchAllEventsForBranchDispatch(branchId));
    },
    handleEventEditClick: (event) => {
      dispatch(openEditEventDialogDispatch(true));
      dispatch(eventEditClickDispatch(event));
    },
    handleEventRecordEditClick: (event) => {
      dispatch(openEditEventPanelDispatch(true));
      dispatch(eventEditClickDispatch(event));
    },
    openDeleteEventDialog: (open, event) => {
      dispatch(openDeleteEventDialogDispatch(open, event));
    },
    submitDeleteEventRequest: (event) => {
      dispatch(submitDeleteEventRequestDispatch(event));
    },
    fetchAllDocuments: (branchId) => {
      dispatch(fetchAllDocumentsDispatch(documentType.DOCUMENT_LIBRARY, branchId ));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventsList);
